module.exports = __webpack_public_path__ + "img/logo-link-blanco.79266c30.png";